import { Constants } from "@/constants/enums";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { JWT } from "@/store/MUTATIONS-TYPES";

Vue.use(VueRouter);

export const ROUTERS = {
  //#region Access Control screens
  ACCESS_CONTROL: {
    LOGIN: {
      PATH: "/login",
      NAME: "Acesse sua conta",
      ICON: "login",
    },
    LOGOUT: {
      PATH: "/logout",
      NAME: "",
      ICON: "login",
    },
    EXPIRED_SESSION: {
      PATH: "/expiredSession",
      NAME: "Sessão Expirada",
      ICON: "update",
    },
    NEWACCOUNT: {
      PATH: "/newAccount",
      NAME: "Criar conta Comercial",
      ICON: "person_add",
    },
    FORGOT_PASSWORD: {
      PATH: "/forgotPassword",
      NAME: "Esqueci minha senha",
      ICON: "mdi-form-textbox-password",
    },
    PASSWORD_RECOVERY: {
      PATH: "/password_recovery/:id",
      NAME: "/password_recovery/:id",
      ICON: "mdi-form-textbox-password",
    },
    CHANGE_PASSWORD: {
      PATH: "/alterarSenhaAcesso",
      NAME: "Alterar senha de acesso",
      ICON: "mdi-lock-reset",
    },
  },
  //#endregion

  //#region Administrative Options
  BUSINESS_UNITS_LIST: {
    PATH: "/businessUnits",
    NAME: "Empresas",
    ICON: "business",
  },
  GROOMERS_LIST: {
    PATH: "/professionals",
    NAME: "Profissionais",
    ICON: "mdi-account-group",
  },
  HIRINGS_LIST: {
    PATH: "/hirings",
    NAME: "Contratações",
    ICON: "mdi-handshake",
  },
  LEVEL_MAMAGEMENT: {
    PATH: "/levels",
    NAME: "Cargos e Níveis",
    ICON: "mdi-chart-bar",
  },
  CRITERIAS: {
    PATH: "/criterias",
    NAME: "Quesitos - Avaliações",
    ICON: "mdi-star",
  },
  BANK_ACCOUNT: {
    PATH: "/finances",
    NAME: "Finanças",
    ICON: "mdi-cash-multiple",
  },
  EXPIRATION_SETTINGS: {
    PATH: "/expirationSettings",
    NAME: "Prazos de Expiração",
    ICON: "mdi-timer-outline",
  },
  FAQ: {
    PATH: "/faq",
    NAME: "FAQ",
    ICON: "mdi-chat-question-outline",
  },
  CAROUSEL_IMAGES: {
    PATH: "/carouselImages",
    NAME: "Imagens da Tela Inicial",
    ICON: "mdi-image-area-close",
  },
  FROZEN_PROFESSIONALS: {
    PATH: "/frozenProfessionals",
    NAME: "Perfis congelados",
    ICON: "mdi-snowflake",
  },
  TRANSACTION_MONITORING: {
    PATH: "/transactionMonitoring",
    NAME: "Acompanhamento de Transações",
    ICON: "mdi-monitor-dashboard",
  },
  //#endregion

  //#region Common Options
  HOME: {
    PATH: "/",
    NAME: "Início",
    ICON: "home",
  },
  SUPPORT: {
    PATH: "/support",
    NAME: "Suporte",
    ICON: "mdi-face-agent",
  },
  SUPPORT_SERVICE: {
    PATH: "/supportService",
    NAME: "Suporte",
    ICON: "mdi-face-agent",
  },
  SUPPORT_REQUEST_DETAILS: {
    PATH: "/support_request/:ticketNumber",
    NAME: "/support_request/:ticketNumber",
    ICON: "mdi-face-agent",
  },
  ABOUT_US: {
    PATH: "/who",
    NAME: "Quem Somos",
    ICON: "",
  },
  POLICIES: {
    PATH: "/policies",
    NAME: "Políticas",
    ICON: "",
  },
  PROFESSIONALS: {
    PATH: "/professionalsCTA",
    NAME: "Profissionais",
    ICON: "",
  },
  JOB_OPPORTUNITIES: {
    PATH: "/jobOpportunities",
    NAME: "Vagas Disponíveis",
    ICON: "mdi-account-voice",
  },
  BUSINESSUNITS: {
    PATH: "/businessUnitsCTA",
    NAME: "Profissionais",
    ICON: "",
  },
  USER_PROFILE: {
    PATH: "/userProfile",
    NAME: "Meu Perfil",
    ICON: "mdi-account-circle-outline",
  },
  USER_PROFILE_EDIT: {
    PATH: "/userProfile/edit",
    NAME: "Editar Perfil",
    ICON: "mdi-account-edit-outline",
  },
  BUSINESS_UNIT_DATA: {
    PATH: "/businessUnit",
    NAME: "Dados da Empresa",
    ICON: "business",
  },
  BUSINESS_UNIT_EDIT: {
    PATH: "/businessUnit/edit",
    NAME: "Editar Empresa",
  },
  SELECTION_PROCESS: {
    PATH: "/hiringProcess",
    NAME: "Vagas",
    ICON: "mdi-account-voice",
  },
  SEARCH_PROFESSIONALS: {
    PATH: "/searchProfessionals",
    NAME: "Buscar Profissionais",
    ICON: "mdi-account-search",
  },
  HIRING: {
    PATH: "/hiring",
    NAME: "Últimas Contratações",
    ICON: "mdi-handshake",
  },
  RATINGS: {
    PATH: "/ratings",
    NAME: "Avaliações",
    ICON: "star",
  },
  JOIN_REQUESTS: {
    PATH: "/joinRequests",
    NAME: "Pedidos de participação",
    ICON: "mdi-account-plus-outline",
  },
  COMPANY_USERS: {
    PATH: "/usuarios",
    NAME: "Usuários",
    ICON: "mdi-account-group-outline",
  },
  HIRING_TEMPLATES: {
    PATH: "/templates",
    NAME: "Templates",
    ICON: "mdi-file-document-multiple-outline",
  },
  GROOMER_RATINGS: {
    PATH: "/groomerRatings",
    NAME: "Avaliações",
    ICON: "star",
  },
  GROOMER_HIRINGS: {
    PATH: "/groomerHirings",
    NAME: "Contratações",
    ICON: "mdi-handshake",
  },
  GROOMER_AGENDA: {
    PATH: "/groomerAgenda",
    NAME: "Agenda",
    ICON: "mdi-calendar-month",
  },
  GROOMER_SELECTION_PROCESS: {
    PATH: "/groomeSelectionProcess",
    NAME: "Convites",
    ICON: "mdi-account-plus",
  },
  PUBLIC_PROFILE_REDIRECT: {
    PATH: "/:nickname",
    NAME: "/:nickname",
    ICON: "",
  },
  BUSINESS_UNIT_PUBLIC_PROFILE: {
    PATH: "/bu/:nickname",
    NAME: "/bu/:nickname",
    ICON: "",
  },
  PERSON_PUBLIC_PROFILE: {
    PATH: "/p/:nickname",
    NAME: "/p/:nickname",
    ICON: "",
  },
  SEARCH: {
    PATH: "/searchResult/:searchContent",
    NAME: "/searchResult/:searchContent",
    ICON: "",
  },
  VAGA_DETAILS: {
    PATH: "/vaga/:publicId",
    NAME: "/vaga/:publicId",
    ICON: "",
  },
  OPPORTUNITY_DETAILS: {
    PATH: "/opportunity_details/:opportunityId/:personId",
    NAME: "/opportunity_details/:opportunityId/:personId",
    ICON: "",
  },
  OPPORTUNITY_ACCEPT: {
    PATH: "/opportunity_response/accept/:opportunityId/:personId",
    NAME: "/opportunity_response/accept/:opportunityId/:personId",
    ICON: "",
  },
  OPPORTUNITY_DENY: {
    PATH: "/opportunity_response/deny/:opportunityId/:personId",
    NAME: "/opportunity_response/deny/:opportunityId/:personId",
    ICON: "",
  },
  HIRE_CONFIRMATION: {
    PATH: "/hire_confirmation/:opportunityId/:personId/:inviteId",
    NAME: "/hire_confirmation/:opportunityId/:personId/:inviteId",
    ICON: "mdi-handshake",
  },
  FAST_ENABLE: {
    PATH: "/fast/enable",
    NAME: "MeuTosadorFast",
    ICON: "mdi-speedometer",
  },
  FAST_HIRING: {
    PATH: "/fast/hiring",
    NAME: "MeuTosador Fast",
    ICON: "mdi-speedometer",
  },
  FAST_HIRING_DETAILS: {
    PATH: "/fast/hiring/details/:personId",
    NAME: "/fast/hiring/details/:personId",
    ICON: "",
  },
  FAST_HIRE_CONFIRMATION: {
    PATH: "/fast_hire_confirmation/:opportunityId/:personId/:inviteId",
    NAME: "/fast_hire_confirmation/:opportunityId/:personId/:inviteId",
    ICON: "mdi-handshake",
  },
  HIRE_DETAILS: {
    PATH: "/hire_details/:publicId",
    NAME: "/hire_details/:publicId",
    ICON: "",
  },
  MAGAZINE_POSTS: {
    PATH: "/magazine/posts",
    NAME: "Revista MeuTosador",
    ICON: "mdi-newspaper",
  },
  MAGAZINE_READER: {
    PATH: "/magazine/:publicId",
    NAME: "/magazine/:publicId",
    ICON: "",
  },
  FAST_HIRING_PAGE: {
    PATH: "/fastHiring/info",
    NAME: "MeuTosador Fast",
    ICON: "",
  },
  CANDIDATE_MANAGEMENT: {
    PATH: "/candidate_management/:publicId",
    NAME: "/candidate_management/:publicId",
    ICON: "",
  },
  CHATS: {
    PATH: "/chats",
    NAME: "Mensagens",
    ICON: "mdi-forum-outline",
  },
  CHATS_THREAD: {
    PATH: "/chats/:id",
    NAME: "Mensagens",
    ICON: "mdi-forum-outline",
  },
  //#endregion
};

const routes: Array<RouteConfig> = [
  //#region Administrative Routes
  {
    path: ROUTERS.BUSINESS_UNITS_LIST.PATH,
    name: ROUTERS.BUSINESS_UNITS_LIST.NAME,
    component: () =>
      import("@/components/administrativeComponents/businessUnitsList"),
    meta: {
      transition: "slide-right",
      roles: [Constants.Enums.PERSONTYPE.ADMINISTRATIVE_USER],
    },
  },
  {
    path: ROUTERS.GROOMERS_LIST.PATH,
    name: ROUTERS.GROOMERS_LIST.NAME,
    component: () =>
      import("@/components/administrativeComponents/professionalsList"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.HIRINGS_LIST.PATH,
    name: ROUTERS.HIRINGS_LIST.NAME,
    component: () =>
      import("@/components/administrativeComponents/hiringsList"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.TRANSACTION_MONITORING.PATH,
    name: ROUTERS.TRANSACTION_MONITORING.NAME,
    component: () =>
      import("@/components/administrativeComponents/transactionMonitoring"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.LEVEL_MAMAGEMENT.PATH,
    name: ROUTERS.LEVEL_MAMAGEMENT.NAME,
    component: () =>
      import("@/components/administrativeComponents/professionsManagement"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.CRITERIAS.PATH,
    name: ROUTERS.CRITERIAS.NAME,
    component: () =>
      import("@/components/administrativeComponents/evaluationCriterias"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.BANK_ACCOUNT.PATH,
    name: ROUTERS.BANK_ACCOUNT.NAME,
    component: () => import("@/components/administrativeComponents/finances"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.EXPIRATION_SETTINGS.PATH,
    name: ROUTERS.EXPIRATION_SETTINGS.NAME,
    component: () =>
      import("@/components/administrativeComponents/expirationSettings"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.FAQ.PATH,
    name: ROUTERS.FAQ.NAME,
    component: () =>
      import("@/components/administrativeComponents/faqManagement"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.CAROUSEL_IMAGES.PATH,
    name: ROUTERS.CAROUSEL_IMAGES.NAME,
    component: () =>
      import("@/components/administrativeComponents/carouselImageManager"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.FROZEN_PROFESSIONALS.PATH,
    name: ROUTERS.FROZEN_PROFESSIONALS.NAME,
    component: () =>
      import("@/components/administrativeComponents/frozenProfessionalsManagement"),
    meta: {
      transition: "slide-right",
    },
  },
  //#endregion

  //#region Access Control Routes
  {
    path: ROUTERS.ACCESS_CONTROL.LOGIN.PATH,
    name: ROUTERS.ACCESS_CONTROL.LOGIN.NAME,
    component: () => import("@/views/login"),
    meta: {
      transition: "slide-right",
      hideChrome: true,
    },
  },
  {
    path: ROUTERS.ACCESS_CONTROL.NEWACCOUNT.PATH,
    name: ROUTERS.ACCESS_CONTROL.NEWACCOUNT.NAME,
    component: () => import("@/views/newPersonAccount"),
    meta: {
      transition: "slide-right",
      hideChrome: true,
    },
  },
  {
    path: ROUTERS.ACCESS_CONTROL.LOGOUT.PATH,
    name: ROUTERS.ACCESS_CONTROL.LOGOUT.NAME,
    component: () => import("@/views/logout"),
    meta: {
      transition: "slide-right",
      hideChrome: true,
    },
  },
  {
    path: ROUTERS.ACCESS_CONTROL.FORGOT_PASSWORD.PATH,
    name: ROUTERS.ACCESS_CONTROL.FORGOT_PASSWORD.NAME,
    component: () => import("@/views/forgotPassword"),
    meta: {
      transition: "slide-right",
      hideChrome: true,
    },
  },
  {
    path: ROUTERS.ACCESS_CONTROL.PASSWORD_RECOVERY.PATH,
    name: ROUTERS.ACCESS_CONTROL.PASSWORD_RECOVERY.NAME,
    component: () => import("@/views/passwordRecovery"),
    meta: {
      transition: "slide-right",
      hideChrome: true,
    },
  },
  {
    path: ROUTERS.ACCESS_CONTROL.CHANGE_PASSWORD.PATH,
    name: ROUTERS.ACCESS_CONTROL.CHANGE_PASSWORD.NAME,
    component: () => import("@/views/changeAccessPassword"),
    meta: {
      transition: "slide-right",
      roles: [
        Constants.Enums.PERSONTYPE.BUSINESS_UNIT,
        Constants.Enums.PERSONTYPE.USER,
        Constants.Enums.PERSONTYPE.ADMINISTRATIVE_USER,
      ],
    },
  },
  //#endregion

  //#region Common Routes
  {
    path: ROUTERS.HOME.PATH,
    name: ROUTERS.HOME.NAME,
    component: () => import("@/views/home"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.SUPPORT.PATH,
    name: ROUTERS.SUPPORT.NAME,
    component: () => import("@/views/support"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.SUPPORT_SERVICE.PATH,
    name: ROUTERS.SUPPORT_SERVICE.NAME,
    component: () => import("@/views/supportService"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.SUPPORT_REQUEST_DETAILS.PATH,
    name: ROUTERS.SUPPORT_REQUEST_DETAILS.NAME,
    component: () =>
      import("@/components/supportComponents/supportRequestDetails"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.JOB_OPPORTUNITIES.PATH,
    name: ROUTERS.JOB_OPPORTUNITIES.NAME,
    component: () => import("@/views/jobOpportunitiesList"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.ABOUT_US.PATH,
    name: ROUTERS.ABOUT_US.NAME,
    component: () => import("@/views/about"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.POLICIES.PATH,
    name: ROUTERS.POLICIES.NAME,
    component: () => import("@/views/policies"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.PROFESSIONALS.PATH,
    name: ROUTERS.PROFESSIONALS.NAME,
    component: () => import("@/views/professionalsScreen"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.BUSINESSUNITS.PATH,
    name: ROUTERS.BUSINESSUNITS.NAME,
    component: () => import("@/views/businessUnitsScreen"),
    meta: {
      transition: "slide-right",
    },
  },
  {
    path: ROUTERS.USER_PROFILE_EDIT.PATH,
    name: ROUTERS.USER_PROFILE_EDIT.NAME,
    component: () => import("@/views/userProfileEdit"),
    meta: {
      transition: "slide-right",
      hideMobileNav: true,
      roles: [
        Constants.Enums.PERSONTYPE.BUSINESS_UNIT,
        Constants.Enums.PERSONTYPE.USER,
        Constants.Enums.PERSONTYPE.ADMINISTRATIVE_USER,
      ],
    },
  },
  {
    path: ROUTERS.USER_PROFILE.PATH,
    name: ROUTERS.USER_PROFILE.NAME,
    component: () => import("@/views/userProfile"),
    meta: {
      transition: "slide-right",
      roles: [
        Constants.Enums.PERSONTYPE.BUSINESS_UNIT,
        Constants.Enums.PERSONTYPE.USER,
        Constants.Enums.PERSONTYPE.ADMINISTRATIVE_USER,
      ],
    },
  },
  {
    path: ROUTERS.BUSINESS_UNIT_EDIT.PATH,
    name: ROUTERS.BUSINESS_UNIT_EDIT.NAME,
    component: () => import("@/views/businessUnitEdit"),
    meta: {
      transition: "slide-right",
      hideMobileNav: true,
      roles: [
        Constants.Enums.PERSONTYPE.BUSINESS_UNIT,
        Constants.Enums.PERSONTYPE.USER,
        Constants.Enums.PERSONTYPE.ADMINISTRATIVE_USER,
      ],
    },
  },
  {
    path: ROUTERS.BUSINESS_UNIT_DATA.PATH,
    name: ROUTERS.BUSINESS_UNIT_DATA.NAME,
    component: () =>
      import("@/components/businessUnitComponents/businessUnitData"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.SELECTION_PROCESS.PATH,
    name: ROUTERS.SELECTION_PROCESS.NAME,
    component: () =>
      import("@/components/businessUnitComponents/opportunitiesManagement"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.SEARCH_PROFESSIONALS.PATH,
    name: ROUTERS.SEARCH_PROFESSIONALS.NAME,
    component: () =>
      import("@/components/businessUnitComponents/searchProfessionals"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.HIRING.PATH,
    name: ROUTERS.HIRING.NAME,
    component: () => import("@/components/hiring"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.RATINGS.PATH,
    name: ROUTERS.RATINGS.NAME,
    component: () => import("@/components/businessUnitComponents/ratings"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.JOIN_REQUESTS.PATH,
    name: ROUTERS.JOIN_REQUESTS.NAME,
    component: () => import("@/components/joinRequestsManagement"),
    meta: {
      transition: "slide-right",
      roles: [
        Constants.Enums.PERSONTYPE.BUSINESS_UNIT,
        Constants.Enums.PERSONTYPE.USER,
      ],
    },
  },
  {
    path: ROUTERS.COMPANY_USERS.PATH,
    name: ROUTERS.COMPANY_USERS.NAME,
    component: () => import("@/components/companyUsers"),
    meta: {
      transition: "slide-right",
      roles: [
        Constants.Enums.PERSONTYPE.BUSINESS_UNIT,
        Constants.Enums.PERSONTYPE.USER,
      ],
    },
  },
  {
    path: ROUTERS.HIRING_TEMPLATES.PATH,
    name: ROUTERS.HIRING_TEMPLATES.NAME,
    component: () => import("@/components/hiringTemplates"),
    meta: {
      transition: "slide-right",
      roles: [
        Constants.Enums.PERSONTYPE.BUSINESS_UNIT,
        Constants.Enums.PERSONTYPE.USER,
      ],
    },
  },
  {
    path: ROUTERS.GROOMER_RATINGS.PATH,
    name: ROUTERS.GROOMER_RATINGS.NAME,
    component: () => import("@/components/groomerComponents/groomerRatings"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.GROOMER_HIRINGS.PATH,
    name: ROUTERS.GROOMER_HIRINGS.NAME,
    component: () => import("@/components/groomerComponents/groomerHirings"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.GROOMER_AGENDA.PATH,
    name: ROUTERS.GROOMER_AGENDA.NAME,
    component: () => import("@/components/groomerComponents/groomerAgenda"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.GROOMER_SELECTION_PROCESS.PATH,
    name: ROUTERS.GROOMER_SELECTION_PROCESS.NAME,
    component: () => import("@/components/groomerComponents/groomerInvites"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.CHATS.PATH,
    name: ROUTERS.CHATS.NAME,
    component: () => import("@/components/chat/chatInbox"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.CHATS_THREAD.PATH,
    name: "Mensagens da conversa",
    component: () => import("@/components/chat/chatInbox"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.VAGA_DETAILS.PATH,
    name: ROUTERS.VAGA_DETAILS.NAME,
    component: () => import("@/views/vacancyDetails"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.PUBLIC_PROFILE_REDIRECT.PATH,
    name: ROUTERS.PUBLIC_PROFILE_REDIRECT.NAME,
    component: () => import("@/views/publicProfileRedirect"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.PERSON_PUBLIC_PROFILE.PATH,
    name: ROUTERS.PERSON_PUBLIC_PROFILE.NAME,
    component: () => import("@/views/userPublicProfile"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.BUSINESS_UNIT_PUBLIC_PROFILE.PATH,
    name: ROUTERS.BUSINESS_UNIT_PUBLIC_PROFILE.NAME,
    component: () => import("@/views/businessUnitPublicProfile"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.SEARCH.PATH,
    name: ROUTERS.SEARCH.NAME,
    component: () => import("@/components/searchSys/searchResults"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.OPPORTUNITY_DETAILS.PATH,
    name: ROUTERS.OPPORTUNITY_DETAILS.NAME,
    component: () => import("@/views/opportunityDetails"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.OPPORTUNITY_ACCEPT.PATH,
    name: ROUTERS.OPPORTUNITY_ACCEPT.NAME,
    component: () => import("@/views/opportunityAccept"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.OPPORTUNITY_DENY.PATH,
    name: ROUTERS.OPPORTUNITY_DENY.NAME,
    component: () => import("@/views/opportunityDeny"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.HIRE_CONFIRMATION.PATH,
    name: ROUTERS.HIRE_CONFIRMATION.NAME,
    component: () => import("@/components/hireComponents/hireConfirmation"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.FAST_HIRE_CONFIRMATION.PATH,
    name: ROUTERS.FAST_HIRE_CONFIRMATION.NAME,
    component: () => import("@/components/hireComponents/fastHireConfirmation"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.HIRE_DETAILS.PATH,
    name: ROUTERS.HIRE_DETAILS.NAME,
    component: () => import("@/components/hireComponents/hireDetails"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.FAST_ENABLE.PATH,
    name: ROUTERS.FAST_ENABLE.NAME,
    component: () => import("@/components/hireComponents/enableFastHiring"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.FAST_HIRING.PATH,
    name: ROUTERS.FAST_HIRING.NAME,
    component: () =>
      import("@/components/businessUnitComponents/fastHIringList"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.FAST_HIRING_DETAILS.PATH,
    name: ROUTERS.FAST_HIRING_DETAILS.NAME,
    component: () =>
      import("@/components/businessUnitComponents/newFastHiringInfos"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },

  {
    path: ROUTERS.MAGAZINE_POSTS.PATH,
    name: ROUTERS.MAGAZINE_POSTS.NAME,
    component: () => import("@/components/landingPageComponents/magazine"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.MAGAZINE_READER.PATH,
    name: ROUTERS.MAGAZINE_READER.NAME,
    component: () =>
      import("@/components/landingPageComponents/magazinePostReader"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  {
    path: ROUTERS.FAST_HIRING_PAGE.PATH,
    name: ROUTERS.FAST_HIRING_PAGE.NAME,
    component: () => import("@/views/FastHiringScreen"),
    meta: {
      transition: "slide-right",
    },
  },

  {
    path: ROUTERS.CANDIDATE_MANAGEMENT.PATH,
    name: ROUTERS.CANDIDATE_MANAGEMENT.NAME,
    component: () => import("@/views/candidateManagement"),
    meta: {
      transition: "slide-right",
      roles: [],
    },
  },
  //#endregion
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const jwt = localStorage.getItem(JWT);

    if (!jwt) {
      if (to.path !== "/login") {
        next({
          path: "/login",
          params: { nextUrl: to.fullPath },
        });
      } else {
        next(false);
      }
    } else {
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      if (to.matched.some((record) => record.meta.is_admin)) {
        if (user.is_admin === 1) {
          next();
        } else if (to.name !== "home") {
          next({ name: "home" });
        } else {
          next(false);
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
  const mainScreen = document.querySelector(".main-app-screen");
  if (mainScreen) {
    mainScreen.scrollTop = 0;
  }
});

export default router;
